<template>
  <div>
    <p class="dialog-checkbox-label my-0"> {{ label }} </p>
    <v-tooltip
      v-model="error"
      left
      >
      <template v-slot:activator="{ attrs }">
        <v-checkbox
          v-if="option"
          :rules="rules"
          :class="error ? 'validation-error': ''"
          :readonly="readonly ? true: false"
          v-model="selected"
          :true-value="true"
          :false-value="false"
          :value="value"
          :label="option.label"
          hide-details
          @change="$emit('input', { name, value: $event })"
        >
        </v-checkbox>
        <div v-else>
          <v-checkbox
            v-for="option in options"
            :key="option.label"
            :value="option.label"
            :rules="rules"
            :label="option.label"
            :class="error ? 'validation-error': ''"
            :readonly="readonly ? true: false"
            v-model="selected"
            hide-details
            @change="$emit('input', { name, value: $event })"
          ></v-checkbox>
        </div>
        <span class=""
          v-bind="attrs"
        ></span>
      </template>
      <span>This field value is invalid</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'DialogCheckbox',
  data: () => ({
    error: false,
    selected: []
  }),
  props: {
    label: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: [Boolean, String, Object, Array],
      default: false
    },
    option: {
      type: [Boolean, Object],
      default: false
    },
    options: {
      type: [Boolean, Array, Object],
      default: false
    },
    rules: {
      type: Array,
      default: () => []
    },
    validate: {
      type: Boolean,
      default: false
    },
    validationType: {
      type: String,
      default: 'required'
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
  },
  created() {
    if (this.options)
      this.options.forEach(el=>{
        if (el.value==true) this.selected.push(el.label)
      })
    else if (this.option.value == true) this.selected = this.option.value
      else this.selected = false
  },
  computed: {

  }
}
</script>

<style lang="scss" >
@import "@/styles/variables.scss";

.dialog-checkbox {
  &-label {
    color: $bh-gray--2;
  }
}
.v-input--checkbox {
  margin: 0;
}
.v-input--is-readonly {
  cursor: default;
  .v-input__slot {
    background-color:$bh-blue--4 !important;
    cursor: default;
  }
  .v-input--selection-controls__ripple {
    cursor: default !important;
  }
  .v-input--selection-controls__input + .v-label {
    cursor: default !important;
  }
}
.v-input.validation-error .v-input__slot {
  background-color:$bh-red !important;
  border-color:$bh-red !important;
}
</style>